import { MasterSocietyApiModel } from '@core/api/model/master/master-society-api.model';
import { MasterSocietyModel } from '@core/domain/model/master/master-society.model';
import { UserDetailMapper } from '../user/user-detail.mapper';

export class MasterSocietyMapper {
  public static modelFromApi(api: Array<MasterSocietyApiModel>): MasterSocietyModel[] {
    return api.map((society) => ({
      ...society,
      role: UserDetailMapper.roleMapper(society.role),
      billingGroups:
        society.gruposFacturacion?.map((value) => ({
          billingGroupId: value.codigo,
          billingGroupName: value.nombre,
        })) ?? [],
      clientType: society.isPyme ? 'PYMES' : 'GGCC',
    }));
  }
}
